import axios from 'axios';
import create from 'zustand';
import { ADMINAPI_BASE_URL } from "utils/base_urls"

const UpdateTypeColorData = async (keyword) => {
    try {
        const response = await axios.post(ADMINAPI_BASE_URL + '/project/api/updatetypecolor', keyword,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem("auth0_token")}`
                }
            });


        if (response.status === 200) {
            return response.data
        };
    } catch (error) {
        return 'Error'
    }
}

const uploadImageData = async (formdataimgobj, keyword) => {
    function resolveAfter2Seconds() {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve('resolved');
            }, 2000);
        });
    }

    function getCookie(name) {
        let cookieValue = null;
        if (document.cookie && document.cookie !== '') {
            const cookies = document.cookie.split(';');
            for (let i = 0; i < cookies.length; i++) {
                const cookie = cookies[i].trim();
                if (cookie.substring(0, name.length + 1) === (name + '=')) {
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    }
    
    try {
        const response = await axios.post(ADMINAPI_BASE_URL + '/project/api/create', formdataimgobj,
            {
                headers: {
                    'content-type': 'multipart/form-data'
                },
                credentials: 'include'
            });

        if (response.status === 200) {
            return response.data
        };
    } catch (error) {
        return 'Error'
    }
}

const updateannotationStyleData = async (keyword) => {
    try {
        const response = await axios.post(ADMINAPI_BASE_URL + '/project/api/updateannotationStyle', keyword,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem("auth0_token")}`
                }
            });

        if (response.status === 200) {
            return response.data
        };
    } catch (error) {
        return 'Error'
    }
}

const AddProjectData = async (keyword) => {
    try {
        const response = await axios.post(ADMINAPI_BASE_URL + '/project/api/addproject', keyword,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem("auth0_token")}`
                }
            });

        if (response.status === 200) {
            return response.data
        };
    } catch (error) {
        return 'Error'
    }
}

const CheckIfUserExistData = async (keyworkd) => {
    try {
        let keyword = {}
        const response = await axios.post(ADMINAPI_BASE_URL + '/project/api/checkifuserexist', keyword,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem("auth0_token")}`
                }
            });
        if (response.status === 200) {
            return response.data
        };
    } catch (error) {
        return 'Error'
    }
}

const AddProjectAnnotation = async (keyword) => {
    try {
        const response = await axios.post(ADMINAPI_BASE_URL + '/project/api/addAnnotation', keyword,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem("auth0_token")}`
                }
            });

        if (response.status === 200) {
            return response.data
        } else {
            return [];
        }
    } catch (error) {
        return 'Error'
    }
}

const removeannotationData = async (keyword) => {
    try {
        const response = await axios.post(ADMINAPI_BASE_URL + '/project/api/removeannotationByid', keyword,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem("auth0_token")}`
                }
            });

        if (response.status === 200) {
            return response.data
        };
    } catch (error) {
        return 'Error'
    }
}

const DeleteProjectByIdData = async (keyword) => {
    try {
        const response = await axios.post(ADMINAPI_BASE_URL + '/project/api/deleteproject', keyword,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem("auth0_token")}`
                }
            });

        if (response.status === 200) {
            return response.data
        };
    } catch (error) {
        return 'Error'
    }
}

const getannotationbyprojectData = async (keyword) => {
    try {
        const response = await axios.post(ADMINAPI_BASE_URL + '/project/api/getannotationbyproject', keyword,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem("auth0_token")}`
                }
            });


        if (response.status === 200) {
            return response.data
        };
    } catch (error) {
        return 'Error'
    }
}

const GetProjectListByTypeData = async (keyword) => {
    try {
        const response = await axios.post(ADMINAPI_BASE_URL + '/project/api/getprojectlistbytype', keyword,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem("auth0_token")}`
                }
            });

        if (response.status === 200) {
            return response.data
        };
    } catch (error) {
        return 'Error'
    }
}

const update_project = async (keyword) => {
    try {
        const response = await axios.post(ADMINAPI_BASE_URL + '/project/api/updateprojectinfo', keyword,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem("auth0_token")}`
                }
            });

        if (response.status === 200) {
            return response.data
        };
    } catch (error) {
        return 'Error'
    }
}
const RemoveTypeItemData = async (typeID) => {
    try {
        let keyword = {};
        keyword.IDTYPE = typeID;
        const response = await axios.post(ADMINAPI_BASE_URL + '/project/api/removetype', keyword,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem("auth0_token")}`
                }
            });

        if (response.status === 200) {
            return response.data
        };
    } catch (error) {
        return 'Error'
    }
}

const gettypedataByIdData = async (ID) => {
    try {
        let keyword = {};
        keyword.IDType = ID;
        const response = await axios.post(ADMINAPI_BASE_URL + '/project/api/getTypeById', keyword,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem("auth0_token")}`
                }
            });

        if (response.status === 200) {
            return response.data
        };
    } catch (error) {
        return 'Error'
    }
}

const getprojectdataByidData = async (ID) => {
    try {
        let keyword = {};
        keyword.IDPROJECT = ID;
        const response = await axios.post(ADMINAPI_BASE_URL + '/project/api/getprojectbyid', keyword,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem("auth0_token")}`
                }
            });


        if (response.status === 200) {
            return response.data
        };
    } catch (error) {
        return 'Error'
    }
}

const GetProjectTypeListData = async (keyworkd) => {
    try {
        let keyword = {};
        const response = await axios.post(ADMINAPI_BASE_URL + '/project/api/gettypelist', keyword,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem("auth0_token")}`
                }
            });
        if (response.status === 200) {
            return response.data
        };
    } catch (error) {
        return 'Error'
    }
}

const AddProjectTypeData = async (keyword) => {
    try {
        const response = await axios.post(ADMINAPI_BASE_URL + '/project/api/addcategory', keyword,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem("auth0_token")}`
                }
            });

        if (response.status === 200) {
            return response.data
        }
    } catch (error) {
        return 500
    }
}

const GetLastRecentEditedProjectData = async () => {
    try {
        const response = await axios.post(ADMINAPI_BASE_URL + '/project/api/getlatest2AddedOrUpdatedProjects', {},
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem("auth0_token")}`
                }
            });

        if (response.status === 200) {
            return response.data
        }
    } catch (error) {
        return 500
    }
}

const addIonKey = async (name, key) => {
    try {
        const response = await axios.post(ADMINAPI_BASE_URL + '/project/api/addIonKey', { "TokenName": name, "TokenKey": key },
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem("auth0_token")}`
                }
            });

        if (response.status === 200) {
            return response.data
        }
    } catch (error) {
        return 500
    }
}

const getUserOrgIonKeys = async () => {
    try {
        const response = await axios.get(ADMINAPI_BASE_URL + '/project/api/getUserOrgIonKeys',
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem("auth0_token")}`
                }
            });

        if (response.status === 200) {
            return response.data
        }
    } catch (error) {
        return 500
    }
}

const deleteIonKeys = async (ids) => {
    try {
        const response = await axios.delete(ADMINAPI_BASE_URL + '/project/api/deleteIonKeys',
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem("auth0_token")}`
                },
                data: { "token_ids": ids }
            });

        if (response.status === 200) {
            return response.data
        };
    } catch (error) {
        return 500
    }
}

const addAssetToProject = async (asset_id, asset_type, token_key, project_id, name, url, description) => {
    try {
        const response = await axios.post(ADMINAPI_BASE_URL + '/project/api/addAssetToProject',
            { asset_id: asset_id, asset_type: asset_type, token_key: token_key, project_id: project_id, name: name, url: url, description: description },
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem("auth0_token")}`
                },
            });

        if (response.status === 200) {
            return response.data
        };
    } catch (error) {
        return 500
    }
}

const getProjectAssets = async (project_id) => {
    try {
        const response = await axios.get(ADMINAPI_BASE_URL + '/project/api/getProjectAssets',
            {
                params: { project_id: project_id },
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem("auth0_token")}`
                },
            });

        if (response.status === 200) {
            return response.data
        }
    } catch (error) {
        return 500
    }
}

const deleteProjectAsset = async (id) => {
    try {
        const response = await axios.delete(ADMINAPI_BASE_URL + '/project/api/deleteProjectAsset',
            {
                data: { ID: id },
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem("auth0_token")}`
                },
            });

        if (response.status === 200) {
            return response.data
        }
    } catch (error) {
        return 500
    }
}

const editProjectAsset = async (id, asset_id, asset_type, name, token_key, url, description) => {
    try {
        const response = await axios.patch(ADMINAPI_BASE_URL + '/project/api/editProjectAsset',
            { id: id, asset_id: asset_id, asset_type: asset_type, name: name, token_key: token_key, url: url, description: description },
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem("auth0_token")}`
                },
            });

        if (response.status === 200) {
            return response.data
        }
    } catch (error) {
        return 500
    }
}

const RequestProjectData = async (keyworkd) => {
    try {
        const response = await axios.request({
            baseURL: ADMINAPI_BASE_URL,
            url: `/project/api/list`
        });

        if (response.status === 200) {
            return response
        };
    } catch (error) {
        return 500;
    }
}

const RequestSearchData = async (keyworkd) => {
    try {
        const response = await axios.request({
            baseURL: 'https://api.mapbox.com/geocoding/v5/mapbox.places',
            url: `/${keyworkd}.json?access_token=pk.eyJ1IjoiZmFzdG1hcCIsImEiOiJja2N4Y3FodWswNmVzMnJudnRwZW8yY3huIn0.vRWDQDzqfwaEFquoc5SF3g`
        });

        if (response.status === 200) {
            return response
        };
    } catch (error) {
        console.log(error);
    }
}

const RequestWeatherData = async (position) => {
    try {
        const response = await axios.request({
            baseURL: 'https://dataservice.accuweather.com/locations/v1/cities/geoposition',
            url: `/search?apikey=hYrGRV3AGNYjqOu2WGqZwA5Gh9ZE2AHd&q=${position}&details=false`
        });

        if (response.status === 200) {
            let location_key = response.data.Key;
            const weatherAPI = await axios.request({
                baseURL: 'https://dataservice.accuweather.com/currentconditions',
                url: `/v1/${parseInt(location_key)}?apikey=hYrGRV3AGNYjqOu2WGqZwA5Gh9ZE2AHd&q=${position}&details=false`
            });
            return weatherAPI.data[0].Temperature.Metric;
        };
    } catch (error) {
        console.log(error);
    }
}

const useStore = create((set, get) => ({
    project_modal_information: undefined,
    project_id: undefined,
    selectedCategory: 'Uncategorized',
    selectedCategoryPK: undefined,
    selectedCategoryColor: '#A0A0A0',
    currentAnnotationId: undefined,
    reloadAnnotationsList: 0,
    setreloadAnnotationsList: (data) => set({ reloadAnnotationsList: data }),
    reloadAssetList: false,
    setreloadAssetList: (data) => set({ reloadAssetList: data }),
    setcurrentAnnotationId: (data) => set({ currentAnnotationId: data }),
    singleannotationeidtion: undefined,
    setsingleannotationeidtion: (data) => set({ singleannotationeidtion: data }),
    currentAnnotationName: undefined,
    setcurrentAnnotationName: (data) => set({ currentAnnotationName: data }),
    currentAnnotationDescription: undefined,
    setcurrentAnnotationDescription: (data) => set({ currentAnnotationDescription: data }),
    currentImageToUploadAnnotation: undefined,
    setcurrentAnnotationIcon: (data) => set({ currentAnnotationIcon: data }),
    currentAnnotationIcon: undefined,
    setcurrentAnnotationColor: (data) => set({ currentAnnotationColor: data }),
    currentAnnotationColor: undefined,
    setcurrentAnnotationAlpha: (data) => set({ currentAnnotationAlpha: data }),
    currentAnnotationAlpha: undefined,
    setcurrentPinSize: (data) => set({ currentPinSize: data }),
    currentPinSize: undefined,
    setcurrentAnnotationWidth: (data) => set({ currentAnnotationWidth: data }),
    currentAnnotationWidth: undefined,
    setcurrentImageToUploadAnnotation: (data) => set({ currentImageToUploadAnnotation: data }),
    setselectedCategoryColor: (data) => set({ selectedCategoryColor: data }),
    setselectedCategoryPK: (data) => set({ selectedCategoryPK: data }),
    setselectedCategory: (data) => set({ selectedCategory: data }),
    getprojectdataByid: async (id) => {
        try {
            return getprojectdataByidData(id);
        } catch (error) {
            console.log(error);
        }
    }, gettypedataById: async (id) => {
        try {
            return gettypedataByIdData(id);
        } catch (error) {
            console.log(error);
        }
    },
    setproject_id: (data) => set({ project_id: data }),
    setproject_modal_information: (data) => set({ project_modal_information: data }),
    CheckIfUserExist: async () => {
        try {
            return CheckIfUserExistData();
        } catch (error) {
            console.log(error);
        }
    },
    AddProjectTypeToDB: async (keyworkd) => {
        try {
            return AddProjectTypeData(keyworkd);
        } catch (error) {
            console.log(error);
        }
    },
    AddAnnotation: async (keyword) => {
        try {
            return AddProjectAnnotation(keyword);
        } catch (error) {
            console.log(error);
        }
    },
    updateannotationStyle: async (keyword) => {
        try {
            return updateannotationStyleData(keyword);
        } catch (error) {
            console.log(error);
        }
    },
    uploadImage: async (formdataimgobj, keyword) => {
        try {
            return uploadImageData(formdataimgobj, keyword);
        } catch (error) {
            console.log(error);
        }
    },
    removeannotation: async (keyword) => {
        try {
            return removeannotationData(keyword);
        } catch (error) {
            console.log(error);
        }
    },
    GetProjectTypeList: async (keyworkd) => {
        try {
            return GetProjectTypeListData(keyworkd);
        } catch (error) {
            console.log(error);
        }
    },
    RemoveTypeItem: async (keyworkd) => {
        try {
            return RemoveTypeItemData(keyworkd);
        } catch (error) {
            console.log(error);
        }
    },
    update_project_data: async (keyworkd) => {
        try {
            return update_project(keyworkd);
        } catch (error) {
            console.log(error);
        }
    }, AddProject: async (keyworkd) => {
        try {
            return AddProjectData(keyworkd);
        } catch (error) {
            console.log(error);
        }
    }, GetProjectListByType: async (keyworkd) => {
        try {
            return GetProjectListByTypeData(keyworkd);
        } catch (error) {
            console.log(error);
        }
    }, DeleteProjectById: async (keyworkd) => {
        try {
            return DeleteProjectByIdData(keyworkd);
        } catch (error) {
            console.log(error);
        }
    }, UpdateTypeColor: async (keyworkd) => {
        try {
            return UpdateTypeColorData(keyworkd);
        } catch (error) {
            console.log(error);
        }
    }, getannotationbyproject: async (keyworkd) => {
        try {
            return getannotationbyprojectData(keyworkd);
        } catch (error) {
            console.log(error);
        }
    }, GetLastRecentEditedProject: async () => {
        try {
            return GetLastRecentEditedProjectData();
        } catch (error) {
            console.log(error);
        }
    },
    addIonKey: async (name, key) => {
        try {
            return addIonKey(name, key)
        } catch (error) {
            console.log(error)
        }
    },
    getUserOrgIonKeys: async () => {
        try {
            return getUserOrgIonKeys()
        } catch (error) {
            console.log(error)
        }
    },
    deleteIonKeys: async (ids) => {
        try {
            return deleteIonKeys(ids)
        } catch (error) {
            console.log(error)
        }
    },
    addAssetToProject: async (asset_id, asset_type, token_key, project_id, name, url = null, description = null) => {
        try {
            return addAssetToProject(asset_id, asset_type, token_key, project_id, name, url, description)
        } catch (error) {
            console.log(error)
        }
    },
    getProjectAssets: async (project_id) => {
        try {
            return getProjectAssets(project_id);
        } catch (error) {
            console.log(error)
        }
    },
    deleteProjectAsset: async (id) => {
        try {
            return deleteProjectAsset(id)
        } catch (error) {
            console.log(error)
        }
    },
    editProjectAsset: async (id, asset_id, asset_type, name, token_key, url = null, description = null) => {
        try {
            return editProjectAsset(id, asset_id, asset_type, name, token_key, url, description)
        } catch (error) {
            console.log(error)
        }
    }

}));

export default useStore;